type ShowHandler = () => void;

let showHandler: ShowHandler | null = null;

/** 合约开仓/计划挂单：反向持仓冲突业务码 */
export const WELFARE_OPPOSITE_OPEN_CODE = 46001;

/** 计划单触发失败原因码 */
export const WELFARE_OPPOSITE_OPEN_FAIL_REASON = 'WELFARE_OPPOSITE_OPEN_CONFLICT';

/** 由页面挂载弹窗后注册，供下单 model 在 46001 时直接唤起 */
export const registerWelfareOppositeOpenModal = (show: ShowHandler) => {
  showHandler = show;
  return () => {
    if (showHandler === show) {
      showHandler = null;
    }
  };
};

export const triggerWelfareOppositeOpenModal = () => {
  showHandler?.();
};

/** 从 axios 成功体 / 拒绝体中提取业务码，避开 AxiosError.code（如 ERR_*） */
export const getBizErrorCode = (payload: any): number | undefined => {
  if (payload == null || typeof payload !== 'object') return undefined;

  const candidates = [
    payload.returnCode,
    payload.response?.data?.returnCode,
    payload.response?.data?.code,
    payload.result?.code,
    typeof payload.code === 'number' ? payload.code : undefined,
    typeof payload.code === 'string' && /^-?\d+$/.test(payload.code) ? Number(payload.code) : undefined,
  ];

  for (const item of candidates) {
    if (item === undefined || item === null || item === '') continue;
    const num = Number(item);
    if (!Number.isNaN(num)) return num;
  }
  return undefined;
};
